"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var SkeletonTableRows = function (props) {
    return (react_1.default.createElement(react_1.default.Fragment, null, Array(props.rows).fill(0).map(function (_, i) { return (react_1.default.createElement(material_1.TableRow, { key: "skelRow-".concat(i) }, Array(props.columns).fill(0).map(function (_, j) { return (react_1.default.createElement(material_1.TableCell, { sx: { minHeight: '3em', minWidth: '5em' }, key: "skel-".concat(i, "-").concat(j) },
        react_1.default.createElement(material_1.Typography, { variant: "body1" },
            react_1.default.createElement(material_1.Skeleton, { animation: "wave", width: "100" })))); }))); })));
};
exports.default = SkeletonTableRows;
